import type { FC } from "react";
import React, { useMemo } from "react";

import cn from "classnames";

import { AVATARS_VIEW_TEXT_TYPOGRAPHY_STYLE_BY_AVATARS_VIEW_SIZE_MAP } from "./constants/sizes";
import { getChildrenRecord } from "../../../utils/react";

import type { AvatarsViewProps } from "./types";

import classes from "./AvatarsView.styl";

export const AVATARSVIEW_DISPLAY_NAME = "AvatarsView";
export const AVATARS_VIEW_DEFAULT_SIZE = "36";
const AVATARS_VIEW_TEST_ID = "avatars-view-test-id";

/**
 * Контейнер для отображения композиции с несколькими компонентами avatar и добавления подписи.
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?node-id=2-90489&node-type=section&t=E3LiCR5U3PvMQE7D-0" target="_blank">Спека</a>
 * @constructor
 */
export const AvatarsView: FC<AvatarsViewProps> = (props) => {
    const {
        size = AVATARS_VIEW_DEFAULT_SIZE,
        "data-tsid": tsid,
        customColorsStyles,
        children,
    } = props;

    const content = useMemo(() => {
        return getChildrenRecord(
            children,
            AVATARSVIEW_DISPLAY_NAME,
            {
                Items: {
                    props: { size },
                    required: true,
                },
                Link: {
                    props: { size },
                },
                Text: {
                    props: {
                        typographyStyle:
                            AVATARS_VIEW_TEXT_TYPOGRAPHY_STYLE_BY_AVATARS_VIEW_SIZE_MAP[
                                size
                            ],
                    },
                },
                Unknown: {
                    skipElement: true,
                },
            },
            { isArrayResult: true },
        );
    }, [children, size]);

    const avatarViewClasses = cn(
        classes["avatars-view"],
        classes[`__size-${size}`],
        customColorsStyles,
    );

    return (
        <div
            className={avatarViewClasses}
            data-tsid={tsid || AVATARS_VIEW_TEST_ID}
            data-uikit={AVATARSVIEW_DISPLAY_NAME}
        >
            {content}
        </div>
    );
};

AvatarsView.displayName = AVATARSVIEW_DISPLAY_NAME;

export default AvatarsView;
